import React from 'react';
import PropTypes from 'prop-types';

const CustomNoRowsOverlay = (props) => {
  return (
    <div
      role="presentation"
      className="ag-overlay-loading-center"
      style={{ height: '9%' }}>
      {props.noRowsMessage}
    </div>
  );
};

CustomNoRowsOverlay.propTypes = {
  noRowsMessage: PropTypes.string,
};

export default CustomNoRowsOverlay;
